// extracted by mini-css-extract-plugin
export default {"template-variant-select-list":"TemplateVariantSelect_template-variant-select-list__lS-QN"};